<template>
  <div class="building-manage-container animated fadeInRight">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('buildingManage.search.title') }}</span>
        <el-button type="text" style="float: right; padding: 3px 0" @click="_moreCondition">
          {{ buildingManageInfo.moreCondition ? $t('common.hide') : $t('common.more') }}
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="buildingManageInfo.conditions.name"
            :placeholder="$t('buildingManage.search.name')" clearable />
        </el-col>
        <el-col :span="6">
          <el-select v-model="buildingManageInfo.conditions.salesStatus" :placeholder="$t('buildingManage.search.salesStatus')"
            style="width:100%" clearable>
            <el-option :label="$t('buildingManage.salesStatusOptions.toBeSold')" value="待售" />
            <el-option :label="$t('buildingManage.salesStatusOptions.onSale')" value="在售" />
            <el-option :label="$t('buildingManage.salesStatusOptions.soldOut')" value="售罄" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="_queryBuildingMethod">
            <i class="el-icon-search"></i>
            {{ $t('common.search') }}
          </el-button>
          <el-button @click="_resetBuildingMethod">
            <i class="el-icon-refresh"></i>
            {{ $t('common.reset') }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card" style="margin-top:20px">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('buildingManage.list.title') }}</span>
        <el-button type="primary" size="small" @click="_openAddBuildingModal">
          <i class="el-icon-plus"></i>
          {{ $t('common.add') }}
        </el-button>
      </div>
      <el-table :data="buildingManageInfo.buildings" border style="width: 100%">
        <el-table-column prop="id" :label="$t('buildingManage.table.id')" align="center" />
        <el-table-column prop="name" :label="$t('buildingManage.table.name')" align="center" />
        <el-table-column prop="intro" :label="$t('buildingManage.table.intro')" align="center" />
        <el-table-column prop="unitPrice" :label="$t('buildingManage.table.unitPrice')" align="center" />
        <el-table-column prop="totalPrice" :label="$t('buildingManage.table.totalPrice')" align="center" />
        <el-table-column prop="salesStatus" :label="$t('buildingManage.table.salesStatus')" align="center" />
        <el-table-column prop="houseType" :label="$t('buildingManage.table.houseType')" align="center" />
        <el-table-column :label="$t('common.operation')" align="center" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openEditBuildingModel(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="_openDeleteBuildingModel(scope.row)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" style="margin-top:20px;text-align:right" />
    </el-card>

    <add-building ref="addBuilding" @success="handleSuccess" />
    <edit-building ref="editBuilding" @success="handleSuccess" />
    <delete-building ref="deleteBuilding" @success="handleSuccess" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listBuildings } from '@/api/oa/buildingManageApi'
import AddBuilding from '@/components/oa/addBuildingView'
import EditBuilding from '@/components/oa/editBuildingView'
import DeleteBuilding from '@/components/oa/deleteBuilding'

export default {
  name: 'BuildingManageList',
  components: {
    AddBuilding,
    EditBuilding,
    DeleteBuilding
  },
  data() {
    return {
      buildingManageInfo: {
        buildings: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          name: '',
          salesStatus: '',
          houseType: '',
          page: 1,
          row: 10,
          communityId: ''
        }
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.buildingManageInfo.conditions.communityId = this.communityId
    this._listBuildings()
  },
  methods: {
    async _listBuildings() {
      try {
        const params = {
          ...this.buildingManageInfo.conditions,
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await listBuildings(params)
        this.buildingManageInfo.buildings = data
        this.page.total = total
      } catch (error) {
        console.error('获取楼盘列表失败:', error)
      }
    },
    _openAddBuildingModal() {
      this.$refs.addBuilding.open()
    },
    _openEditBuildingModel(row) {
      this.$refs.editBuilding.open(row)
    },
    _openDeleteBuildingModel(row) {
      this.$refs.deleteBuilding.open(row)
    },
    _queryBuildingMethod() {
      this.page.current = 1
      this._listBuildings()
    },
    _resetBuildingMethod() {
      this.buildingManageInfo.conditions = {
        name: '',
        salesStatus: '',
        houseType: '',
        page: 1,
        row: 10,
        communityId: this.communityId
      }
      this._listBuildings()
    },
    _moreCondition() {
      this.buildingManageInfo.moreCondition = !this.buildingManageInfo.moreCondition
    },
    handleSuccess() {
      this._listBuildings()
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listBuildings()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listBuildings()
    }
  }
}
</script>

<style lang="scss" scoped>
.building-manage-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .no_display {
    display: none;
  }
}
</style>